module.exports = __webpack_public_path__ + "static/media/Icons_call_feedback.ebdc4a37.svg";